import { render, staticRenderFns } from "./SeveritySelector.vue?vue&type=template&id=fce3e846&scoped=true&"
import script from "./SeveritySelector.vue?vue&type=script&lang=ts&"
export * from "./SeveritySelector.vue?vue&type=script&lang=ts&"
import style0 from "./SeveritySelector.vue?vue&type=style&index=0&id=fce3e846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce3e846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSelect,VTextField})
